import React from 'react';

export default ({
  playlist,
  sequences,
  seconds,
  seekTo,
  visible,
}) => {
  const actual = playlist.map(slug => sequences[slug]).filter(s => s && s.durationT)
  const duration = actual
  .reduce((total, s) => total + s.durationT, 0);
  return (
    <div className={`railway ${visible ? '' : 'is-hidden'}`}>
      <div className="railway-bg" />
      <div className="railway-line" />
      <ul className="sequences-container">
        {
          actual.map((item, index) => {
            const handleClick = () => {
              seekTo(item.beginT)
            }
            const active = item.beginT <= seconds && item.endT >= seconds;
            return (
              <li
                key={index}
                className={`sequence-block ${active ? 'is-active': ''}`}
                onClick={handleClick}
                style={{
                  height: (item.durationT) / duration * 100 + '%'
                }}
              />
            )
          })
        }
      </ul>
    </div>
  )
}